module.exports = __webpack_public_path__ + "static/media/logo.04486382.svg";